export class LocationAttributesConstants {
    public static headerText: string = 'Hierarchy Attributes';
    public static rightsidePanelId: string = 'rightside'; 
    public static filterPlaceHolderText: string = 'Attributes filter';
    public static activateDialogText: string = 'Activate Attribute';
    public static addListDialogText: string = 'Add List';
    public static deactivateDialogText: string = 'Deactivate Attribute';
    public static deleteDialogText: string = 'Delete Attribute';
    public static cannotDeleteDialogText: string = 'Cannot Delete';
    public static manageListItemsDialogText: string = 'Manage List Items';
    public static editListItemsForDialogText: string = 'Editing list items for';
    public static actionConfirmDialogQuestionText: string = 'Are you sure?';
    public static cannotDeletePromptDeactivateDialogQuestionText: string = "This attribute has data against it in the tenant system. Do you want to de-activate instead?";
    public static cannotDeleteDialogQuestionText: string = "This attribute has data against it in the tenant system, and it is already de-activated";
    public static cannotDeleteReasonPromptDeactivate: string = "UnableToDeleteHasAssociatedDataCanDeactivate";
    public static cannotDeleteReasonAlreadyDeactivated: string = "UnableToDeleteHasAssociatedData";
    public static yes: string = 'Yes';
    public static no: string = 'No';
    public static ok: string = 'OK';
    public static cancel: string = 'Cancel';
}
